
import { IPasswordFormControlOptions } from "../password-form-control";
import { _SSControlOptionsBase } from "./types/_ss-control-options-base";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";

export class SSPaswordOptions implements _SSControlOptionsBase<'password'> {

  constructor(
    private _initialOptions?: IPasswordFormControlOptions
  ) {

    this._initOptions()
  }

  private _initOptions() {

    FormControlOptionsUtils.initMappedObject<'password'>(this, this._initialOptions);
  }

  dispose() {

  }
}
